import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useRoute } from 'src/router/hooks';

export const useNavigateTo404 = (condition: boolean, additionalDependencies?: any[]) => {
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  useEffect(() => {
    if (condition) {
      navigate(ROUTE[404].get(), { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [condition, ...(additionalDependencies || [])]);
};
